import React from "react";
import {
  AutocompleteInput,
  CreateProps,
  ReferenceInput,
  required,
  SimpleForm,
  Toolbar,
} from "react-admin";
import { Grid } from "@material-ui/core";
import SelectedSchoolInput from "../../components/SelectedSchoolInput";
import SanitizedGrid from "../../components/SanitizedGrid";
import { SchoolIdSelected } from "utils/tools";
import CustomMonthPickerInput from "../../components/CustomMonthPickerInput";
import CustomWaveInput from "../../components/CustomWaveInput";
import CustomRouteInput from "../../components/CustomRouteInput";
import CreateWrapper from "../../components/CreateWrapper";
import SaveButtonExcludeBusAssistant from "./components/SaveButtonExcludeBusAssistant";

const CustomToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButtonExcludeBusAssistant formInvalid={props.invalid} />
    </Toolbar>
  );
};

const ExcludeBusAssistantCreate = (props: CreateProps) => {
  const schoolIdSelected = SchoolIdSelected();

  // Used to prevent select the past month
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // getMonth() returns 0-based month (0 = Jan)
  const currentYear = now.getFullYear();

  const breadcrumb = [
    { title: "Exclude Bus Assistants", link: "/excludeBusAssistants" },
    { title: "Create", link: "/excludeBusAssistants/create" },
  ];

  return (
    <CreateWrapper
      breadcrumb={breadcrumb}
      headerTitle="New Exclude Bus Assistant"
      isHaveSchoolFilter
      {...props}
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={4}>
            <ReferenceInput
              label="Subcontractor"
              source="subcontractorId"
              reference="subcontractors"
              validate={required()}
              filterToQuery={(searchText: any) => {
                if (searchText !== "") return { search: searchText };
              }}
            >
              <AutocompleteInput optionText="name" />
            </ReferenceInput>
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <SelectedSchoolInput schoolIdSelected={schoolIdSelected} disabled />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <CustomWaveInput isRequired />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <CustomRouteInput
              source="routeIds"
              isRequired
              multipleSelection
              isShowWarningAlert
            />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <CustomMonthPickerInput
              name="excludedMonth"
              label="Excluded Month"
              minMonth={currentMonth}
              minYear={currentYear}
              isRequired
            />
          </Grid>
          <Grid item xs={8}></Grid>
        </SanitizedGrid>
      </SimpleForm>
    </CreateWrapper>
  );
};

export default ExcludeBusAssistantCreate;
